import React, { useCallback } from 'react';
import { getMessage } from '@tcc/i18n';
import { useDispatch, useSelector } from 'react-redux';
import MessagePanel from 'messages/MessagePanel';
import { closeMessage } from 'messages';
import { getAllMessages } from 'messages/selectors';
import WizardSystem, { Step } from 'common/WizardSystem';
import { getSharedSchema } from '../common/schemas';
import { FieldSelection } from '../common/FieldSelection';
import { ScriptGeneration } from '../common/ScripGeneration';
import { ReviewAndDownload } from './ReviewAndDownload';
import { Button, ComponentSize, FdsIcon, Icon } from '@tcc/fds';
import { printElement } from 'util/print';
import { REVIEW_AND_DOWNLOAD_CLASS_NAME } from '../common/constants';
import { FinishModal } from './FinishModal';
import { navigateToUrl } from 'util/routes';
import { useRedirectUrl } from 'util/hooks/useRedirectUrl';
import { PRECEON_BRAND_UUID } from 'constants/products';

export default function FieldLevelSeedRecs() {
  const dispatch = useDispatch();
  const messages = useSelector(getAllMessages);
  const redirectUrl = useRedirectUrl();

  const handleCloseToast = useCallback(
    (id: string) => {
      dispatch(closeMessage(id));
    },
    [dispatch]
  );

  const steps: Step[] = [
    {
      component: <FieldSelection description={`1. ${getMessage('field-level-seed-recs-description__step_1')}`} />,
      title: getMessage('field-level-seed-recs-title__step_1'),
    },
    {
      component: <ScriptGeneration multipleHybrids excludedBrandUuids={[PRECEON_BRAND_UUID]} />,
      title: getMessage('field-level-seed-recs-title__step_2'),
    },
    {
      component: <ReviewAndDownload />,
      title: getMessage('field-level-seed-recs-title__step_3'),
    }
  ];

  const onClose = useCallback(() => {
    navigateToUrl(redirectUrl);
  }, [redirectUrl]);

  return (
    <>
      <MessagePanel
        closeMessage={handleCloseToast}
        isToolbarShown={false}
        messages={messages}
      />
      <WizardSystem
        steps={steps}
        wizardTitle={getMessage('field-level-seed-recs-wizard-title')}
        onClose={onClose}
        schema={getSharedSchema}
        defaultValues={{ fields: [] }}
        lastStepActions={[
          <Button
            key="print-recommendations-button"
            testId="wizard-footer-print-button"
            type="button"
            size={ComponentSize.Lg}
            onClick={() => printElement({ className: REVIEW_AND_DOWNLOAD_CLASS_NAME })}
          >
            <Icon icon={FdsIcon.Print} />
            {getMessage('button-print')}
          </Button>,
          <FinishModal key="finish-field-level-seed-recs-flow" />
        ]}
      />
    </>
  );
};
